import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getDashboardRoute } from "./authHelpers";

export default function PublicOnlyRoute({ children }) {
  const { user } = useAuth();

  if (user) {
    const target = getDashboardRoute(user.role, user.etablissement_slug);
    // Sécurité : si le rôle est inconnu, getDashboardRoute renvoie "/login",
    // ce qui bouclerait indéfiniment sur ce même garde.
    if (target !== "/login") {
      return <Navigate to={target} replace />;
    }
  }

  return children;
}